import React, { useEffect, useState } from "react";
import "react-table-v6/react-table.css";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import { Col, Container, Row, Table } from "react-bootstrap";
import Footer from "../commonAdmin/Footer";
import Loader from "../../common/Loader";

import {
  Link,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import delivaApiService from "../../../common/services/apiService";

import { ReactComponent as Edit } from "./../../../assets/images/icons/edit.svg";
import AddOrganization from "./AddOrganization";


const OrganizationList = (props) => {
  // hooks
  const history = useHistory();
  // state management
  const [loading, setLoading] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [pageArray, setPageArray] = useState([]);
  const [records, setRecords] = useState(10);
  const [inputRecords, setInputRecords] = useState(10);
  const [sortBy, setSortBy] = useState("id");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [totalRecords, setTotalRecords] = useState("");
  const [editOrgId, setEditOrgId] = useState(null);

  useEffect(() => {
    getAllOrganizationList();
  }, [pageno, records, sortBy, sortOrder]);

  // Function to open the modal
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditOrgId(null);
  };

  // Prepare pagination array as per available records
  const generatePageArray = (totalPages, currentPage) => {
    let startPage, endPage;
    switch (true) {
      case totalPages <= 5:
        startPage = 1;
        endPage = totalPages;
        break;

      case currentPage <= 3:
        startPage = 1;
        endPage = 5;
        break;

      case currentPage + 1 >= totalPages:
        startPage = totalPages - 4;
        endPage = totalPages;
        break;

      default:
        startPage = currentPage - 2;
        endPage = currentPage + 2;
        break;
    }
    const pageArray = [];
    for (let i = startPage; i <= endPage; i++) {
      pageArray.push(i);
    }
    return pageArray;
  };

  // Manage switch pages through Pagination
  const onChangePage = (page) => {
    if (page >= 1 && page <= totalPage) {
      setPageno(page);
      localStorage.setItem("pageno", JSON.stringify(page));
    }
  };

  // Set No. of records per page
  const onChangeItemPerPage = (e) => {
    const rawValue = e.target.value;
    if (rawValue === "" || /^[1-9][0-9]*$/.test(rawValue)) {
      setInputRecords(rawValue);
    }
  };

  const onEnterPerPage = (e) => {
    if (e.key === 'Enter') {
      const val = inputRecords;
      if (val && val > 0) {
        setRecords(parseInt(val));
        setPageno(1);
        localStorage.setItem("pageno", JSON.stringify(1));
      }
    }
  };

  // ASC/DESC Sorting

  const handleSortChange = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
      console.log("sorting.....", sortOrder);
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  // API for get all REFERRAL and PROMO LIST
  const getAllOrganizationList = async () => {
    try {
      setLoading(true);
      const payload = {
        page: pageno - 1,
        size: records,
        sortBy: sortBy,
        sortOrder: sortOrder,
      };
      const { data: response } = await delivaApiService(
        "getOrganizationList",
        payload
      );
      if (response?.status === 200) {
        let data = response?.resourceData;
        setOrganizationList(data?.resourceData);
        const totalRecords = data?.totalRecords || 0;
        const totalPages = records ? Math.ceil(totalRecords / records) : 1;
        setTotalPage(totalPages);
        setPageArray(generatePageArray(totalPages, pageno));
        setLoading(false);
        setTotalRecords(totalRecords);
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    } finally {
      setLoading(false);
    }
  };

  const editOrganization = (orgId) => {
    setEditOrgId(orgId);
    handleOpenModal();
  };

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <div className="d-flex justify-content-between mb-3 align-items-center">
                  <div className="">
                    <h3 className="font-weight-normal mb-0 line-ht fs-24 color-33 text-nowrap">
                      Organization{" "}
                      <span className="color-grey">({totalRecords || 0})</span>
                    </h3>
                  </div>
                  <div className="text-right">
                    <div className="d-flex gap-3">
                      
                      <button
                        className="button rounded-pill btnPrimary text-nowrap px-4 py-2"
                        onClick={handleOpenModal}
                      >
                        <span className="fs20">+</span> Add Organization
                      </button>
                      
                    </div>
                  </div>
                </div>

                <Table responsive>
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        ID{" "}
                        <Link
                          className="icon-up-and-down color-light-grey"
                          onClick={() => handleSortChange("id")}
                        />
                      </th>

                      <th>
                        Name{" "}
                        <Link
                          className="icon-up-and-down color-light-grey"
                          onClick={() => handleSortChange("name")}
                        />
                      </th>
                      <th>
                        Email{" "}
                        <Link
                          className="icon-up-and-down color-light-grey"
                          onClick={() => handleSortChange("email")}
                        />{" "}
                      </th>

                      <th>
                        Employee{" "}
                      </th>

                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody className="ttl-order-table">
                    {organizationList?.length > 0 ? (
                      organizationList.map((org, index) => (
                        <tr
                          key={"org" + index}
                        >
                          <td style={{ maxWidth: "25px" }}>
                          </td>
                          <td>{`#${org?.orgId}`}</td>

                          <td>{org?.name ? org?.name : "--"}</td>
                          <td>{org?.email ? org?.email : "--"}</td>
                          <td>
                            {org?.employeeCount ? org?.employeeCount : "--"}
                          </td>
                          <td>
                            <div className="action-buttons d-flex w-100">
                              <span
                                className="links pointer"
                                role="button"
                                tabIndex={0}
                                onClick={() =>
                                  history.push(
                                    `/organizationDetails/${org?.orgId}`
                                  )
                                }
                                title="View Details"
                              >
                                <i className="icon-eye"></i>
                              </span>

                              <span
                                onClick={() => editOrganization(org?.orgId)}
                                className={`links pointer `}
                                role="button"
                                tabIndex={0}
                                title={"Edit Organization"}
                              >
                                <Edit />
                              </span>

                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                {organizationList?.length > 0 && (
                  <nav
                    aria-label="Page navigation "
                    className="position-relative"
                  >
                    <ul className="pagination pg-blue deliva-pagination justify-content-end">
                      <li className="page-item">
                        <button
                          className="page-link rotate-180 control-btn"
                          aria-label="Previous"
                          onClick={() => onChangePage(pageno - 1)}
                          disabled={pageno === 1}
                          // disabled={!ref?.active}
                        >
                          <span className="icon-next"></span>
                          <span className="sr-only">Previous</span>
                        </button>
                      </li>

                      {pageArray?.map((page, ind) => (
                        <li key={ind} className="page-item">
                          <a
                            className={`page-link ${
                              pageno === page ? "active" : ""
                            }`}
                            onClick={() => onChangePage(page)}
                          >
                            {page}
                          </a>
                        </li>
                      ))}

                      <li className="page-item">
                        <button
                          className="page-link control-btn"
                          aria-label="Next"
                          onClick={() => onChangePage(pageno + 1)}
                          disabled={pageno === totalPage}
                        >
                          <span className="icon-next"></span>
                          <span className="sr-only">Next</span>
                        </button>
                      </li>

                      <li className="page-value">
                        Enter Per Page{" "}
                        <input
                          type="text"
                          placeholder="10"
                          name="records"
                          value={inputRecords}
                          onChange={onChangeItemPerPage}
                          onKeyDown={onEnterPerPage}
                        />
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </Container>
            {/* --- Conditional Rendering in the return statement --- */}

            {isModalOpen && (
              <AddOrganization
                orgId={editOrgId}
                mode={editOrgId ? "edit" : "add"}
                onSuccess={getAllOrganizationList}
                onClose={handleCloseModal}
                onHide={handleCloseModal}
              />
            )}
            <Footer {...props} />
          </Col>
        </Row>
      </div>
      <Loader showLoader={loading} />
    </div>
  );
};
export default OrganizationList;
